import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

export const TermsPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Terms of Service</PageTitle>
        <PageSubtitle>Last updated: 2026. Content migrated from WordPress — update with final legal text.</PageSubtitle>
      </MarketingSection>
      <MarketingSection>
        <h2>Acceptance of terms</h2>
        <p>By using Equa, you agree to these terms. If you do not agree, do not use our services.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Use of service</h2>
        <p>You agree to use the service only for lawful purposes and in accordance with these terms and applicable law.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Account and data</h2>
        <p>You are responsible for maintaining the confidentiality of your account and for all activity under your account.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Contact</h2>
        <p>For questions: <a href="mailto:support@equa.cc" style={{ color: '#3292C0' }}>support@equa.cc</a></p>
      </MarketingSection>
    </MarketingPageContainer>
  </MarketingLayout>
)
